import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';

export enum InviteStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  RE_INVITED = 'RE_INVITED',
}

interface IProps {
  authorizedUserId: string;
  customerId: string;
  inviteStatus: InviteStatus;
  isAuthorizedUser?: boolean;
}

export const mutateInviteStatus = () =>
  useMutation(
    'mutateInviteStatus',
    async ({ authorizedUserId, inviteStatus, customerId, isAuthorizedUser }: IProps) => {
      let endpoint = '';

      if (isAuthorizedUser) {
        endpoint = `${BASE_URL}/api/v1/authorized/user/${authorizedUserId}/user/${customerId}/invite`;
      } else {
        endpoint = `${BASE_URL}/api/v1/user/${customerId}/authorized/user/${authorizedUserId}/invite`;
      }

      const res = await httpService.put(endpoint, {
        inviteStatus,
      });
      return res.data;
    },
  );
